export const LOGIN_MODAL_SEEN_KEY = 'loginModalSeen';
